export class ManufacturerContentModel {
    public manufacturerId: number;
    public langId: number;
    public name: string;
    public address: string;
    public city: string;
    public country: string;
}